import React, { CSSProperties, FC } from 'react';
import { Icon }                     from 'semantic-ui-react';

import { CenteredContentContainer, StyledContainer, StyledContainerProps } from '../../../containers';
import { LoadingIndicator }                                                from './LoadingIndicator';

interface Props {
	label?: string,
	active?: boolean,
	fill?: StyledContainerProps['fill'],
	style?: CSSProperties,
}

const defaultProps: Props = {
	label:  'Loading...',
	active: true,
	fill:   'area',
	style:  {}
}

const BigGearLoadingMessage: FC<Props> = ( props ) => {
	
	if( !props.active ) return null;
	
	return (
		
		<StyledContainer fill={ props.fill } style={ props.style }>
			
			<LoadingIndicator isActive={ true } inverted label={ props.label }/>
			
			<CenteredContentContainer className={ 'container--fill-area text-center' }>
				<Icon name={ 'cog' } size={ 'massive' } color={ 'grey' } fitted loading style={ { fontSize: '16em', animationDuration: '25s' } }/>
			</CenteredContentContainer>
		
		</StyledContainer>
	);
};

BigGearLoadingMessage.defaultProps = defaultProps;

export { BigGearLoadingMessage }
